import React, { useState } from "react";
import {
    Container,
    Tabs,
    Tab,
    Box,
} from "@mui/material";
import CloudUploadRoundedIcon from "@mui/icons-material/CloudUploadRounded";
import LinkRoundedIcon from "@mui/icons-material/LinkRounded";
import UploadMenu from "./Upload";
import UploadURLQR from "./UploadUrl";
import CreateSpecialRecord from "./CreateSpecialRecord";
import UploadFlexibleQr from "./UploadFlexibleQr";

export default function UploadRecord() {
    const [tabIndex, setTabIndex] = useState(0);

    const handleTabChange = (event, newValue) => {
        setTabIndex(newValue);
    };

    return (
        <Container maxWidth="md" className="upload-record-container upload-page-shell">
            <Box className="upload-tabs-shell">
                <Tabs
                    value={tabIndex}
                    onChange={handleTabChange}
                    variant="scrollable"
                    scrollButtons="auto"
                    allowScrollButtonsMobile
                    textColor="primary"
                    indicatorColor="primary"
                    className="upload-tabs"
                    sx={{ "& .MuiTabs-flexContainer": { justifyContent: "center" } }}
                >
                    <Tab icon={<CloudUploadRoundedIcon fontSize="small" />} iconPosition="start" label="File" />
                    <Tab icon={<LinkRoundedIcon fontSize="small" />} iconPosition="start" label="URL" />
                    <Tab icon={<LinkRoundedIcon fontSize="small" />} iconPosition="start" label="Website" />
                    <Tab icon={<LinkRoundedIcon fontSize="small" />} iconPosition="start" label="Survey" />
                    <Tab icon={<LinkRoundedIcon fontSize="small" />} iconPosition="start" label="More" />
                </Tabs>
            </Box>

            <Box className="upload-tab-panel">
                {tabIndex === 0 && <UploadMenu />}
                {tabIndex === 1 && <UploadURLQR />}
                {tabIndex === 2 && <CreateSpecialRecord type="website" />}
                {tabIndex === 3 && <CreateSpecialRecord type="survey" />}
                {tabIndex === 4 && <UploadFlexibleQr />}
            </Box>
        </Container>
    );
}
